import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import './points.scss';
import axios from '../../axios'
import Search from "../Search/Search";
import ReactPaginate from "react-paginate";
import Loader from "../Loader/Loader";


const Points = () => {
    const [users, setusers] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // pagination
    const [pageNumber, setPageNumber] = useState(0);
    const productsPerPage = 8;
    const productsPerList = 50;
    const pagesVisited = pageNumber * productsPerPage;
    let displayUsers = [];
    const pageCount = Math.ceil(filtered.length / productsPerPage);

    const changePage = ({selected}) => {
        console.log(selected)
        setPageNumber(selected);
    };

    useEffect(() => {
        axios.get('point/all').then((res) => {
            setusers(res?.data);
            setFiltered(res?.data)
            setIsLoading(false)
        }).catch((err) => {
            console.log(err)
        });
    }, [])

    return (
        <div className='points p-5 text-left'>
            <div className='page-title'>
                <h1>Points</h1> <br/>
            </div>
            <div className='row search-add'>
            <Search data={users} filtered={setFiltered} setPageNumber={setPageNumber}/>
                <Link to='/points/add-point' className='myButton'>Add New Point</Link>
            </div>
            <div className='row'>
            <div className='row list-description mb-2'>
                            {/*<div className='col-1'>{filtered.id} </div>*/}
                            <div className='col-1'>Point Id</div>
                            <div className='col-2'>Name</div>
                            <div className='col-3'>Latitude</div>
                            <div className='col-3'>Longitude</div>
                            <div className='col-1'>Status</div>
                            <div className='col-1'>Edit</div>
                            <div className='col-1'>Delete</div>
                            </div>
                {
                    isLoading ? <Loader/> :
                        displayUsers = filtered?.slice
                    (pagesVisited, pagesVisited + productsPerPage)?.map
                    (filtered => {
                        console.log(filtered)
                    return (<div className='listimi showme' key={filtered.id}>
                        <div className='row '>
                            {/*<div className='col-1'>{filtered.id} </div>*/}
                            <div className='col-1'>{filtered.id} </div>
                            <div className='col-2'>{filtered.name} </div>
                            <div className='col-3'>{filtered.latitude} </div>
                            <div className='col-3'>{filtered.longitude} </div>
                            {/*<div className='col-3'>{el.longitude} </div>*/}
                            {/*<div className='col-3'>{el.latitude} </div>*/}
                            <div className='col-1'>{filtered.active ? 'Active' : 'Passive'} </div>
                            <div className='col-1 hideme'>
                                <Link className={'fa fa-edit'}
                                      to={'/points/edit-point/' + filtered.id}>
                                </Link>
                            </div>
                            <div className='col-1 hideme'>
                                <Link className={'fa fa-trash'}
                                      to={'/points/delete/' + filtered.id}>
                                </Link>
                            </div>
                        </div>
                    </div>)
                })}
            </div>
            <div className="row mt-5">
                <div className="col-12">
                    {(users.length >= productsPerPage) ?
                        <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                        /> : ''
                    }
                </div>
            </div>
        </div>
    )

}

export default Points;